import { useEffect, useState } from "react";
import { useMailView } from "contexts/mailViewContext/mailViewContext";
import { useMail } from "contexts/mailContext/mailContext";

const useMultiSelectionHandler = () => {
  const { getFilesList } = useMail();

  const {
    toggleFileSelect,
    getFilesSelection,
    getFileSelected,
    setFilesSelection,
    setRemoveModeItemId,
    getRemoveModeItemId,
    setShiftModeSelectedItemId,
    getShiftModeSelectedItemId,
  } = useMailView();

  // widnows selection logic
  const [shiftPressed, setShiftPressed] = useState(false);
  const [ctrlPressed, setCtrlPressed] = useState(false);
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.shiftKey) {
        setShiftPressed(true);
      }
      if (event.ctrlKey) {
        setCtrlPressed(true);
      }
    };

    const handleKeyUp = (event: KeyboardEvent) => {
      if (!event.shiftKey) {
        setShiftPressed(false);
      }
      if (!event.ctrlKey) {
        setCtrlPressed(false);
        setRemoveModeItemId(null);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("keyup", handleKeyUp);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  const handleSelectItem = (itemId: number) => {
    if (shiftPressed && getFilesSelection().length > 0) {
      // detect last selected item within the list
      // it can be either removeModeItemId, first on shiftSelection if it continues, or just last selected item
      const lastSelectedItem =
        getRemoveModeItemId() ||
        getShiftModeSelectedItemId() ||
        getFilesSelection()[getFilesSelection().length - 1];

      // setting this item as current shift mode selection itemId
      setShiftModeSelectedItemId(lastSelectedItem);

      // find its index within filesList
      const lastSelectedItemIndex = getFilesList().findIndex(
        (id: number) => id === lastSelectedItem
      );
      // find current item index
      const currentItemIndex = getFilesList().findIndex(
        (id: number) => id === itemId
      );

      // findt where is start and end of the selection
      const startOfSelection = Math.min(
        lastSelectedItemIndex,
        currentItemIndex
      );
      const endOfSelection = Math.max(lastSelectedItemIndex, currentItemIndex);

      if (endOfSelection - startOfSelection > 1) {
        // getting all files between start and end of selection
        const newFilesSelection = getFilesList().slice(
          startOfSelection,
          endOfSelection + 1
        );

        // if ctrl is pressed need to add/remove this files to/from existing selection
        if (ctrlPressed) {
          if (getRemoveModeItemId()) {
            // Remove items if already selected and Ctrl + Shift is pressed
            const updatedSelection = getFilesSelection().filter(
              (item: number) => !newFilesSelection.includes(item)
            );
            setFilesSelection(updatedSelection);
          } else {
            // getting new selection ignoring duplicates
            const newCombineSelection = Array.from(
              new Set([...getFilesSelection(), ...newFilesSelection])
            );
            setFilesSelection(newCombineSelection);
          }
        } else {
          // otherwise use only this selection as new selected files
          setFilesSelection(newFilesSelection);
        }
      } else {
        toggleFileSelect(itemId);
      }
    } else {
      // if file selected already and user using ctrl - its mean removing mode
      if (ctrlPressed && getFileSelected(itemId)) {
        setRemoveModeItemId(itemId);
      } else {
        // otherway reseting it
        setRemoveModeItemId(null);
      }
      // reseting shiftModeSelectionItem to null(will be choose last selected)
      setShiftModeSelectedItemId(null);
      toggleFileSelect(itemId);
    }
  };

  return handleSelectItem;
};

export default useMultiSelectionHandler;
